(function () {
  function initRecommend(section) {
    var content = section.querySelector('.product-rebuy-content');
    if (!content) return;
    var update = function () {
      section.classList.toggle('is-loaded', !!content.querySelector('.grid__item'));
    };
    update();
    new MutationObserver(update).observe(content, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('[data-npd-recommend]').forEach(initRecommend);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
